module.exports = __webpack_public_path__ + "static/pof-logo-d1db7e6e414596ef8a94bbd117697c2f.png";